module.exports = __webpack_public_path__ + "static/media/illustrations-wave-of-emotion.1f8051cf.svg";